import {
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  subDays,
  subWeeks,
  subMonths,
  subYears,
  formatISO,
} from "date-fns";

/** Preset keys used by the analytics filter bar */
export const DATE_PRESETS = [
  { id: "today", label: "اليوم" },
  { id: "yesterday", label: "أمس" },
  { id: "thisWeek", label: "هذا الأسبوع" },
  { id: "lastWeek", label: "الأسبوع الماضي" },
  { id: "thisMonth", label: "هذا الشهر" },
  { id: "lastMonth", label: "الشهر الماضي" },
  { id: "thisYear", label: "هذه السنة" },
  { id: "lastYear", label: "السنة الماضية" },
  { id: "custom", label: "مخصص" },
];

/**
 * Resolve a preset id (or custom from/to) into ISO start/end for the API.
 * Week starts on Sunday to match backend Egypt DayOfWeek.
 */
export const resolveDateRange = (presetId, customFrom, customTo) => {
  const now = new Date();

  let from;
  let to;

  switch (presetId) {
    case "today":
      from = startOfDay(now);
      to = endOfDay(now);
      break;
    case "yesterday": {
      const y = subDays(now, 1);
      from = startOfDay(y);
      to = endOfDay(y);
      break;
    }
    case "thisWeek":
      from = startOfWeek(now, { weekStartsOn: 0 });
      to = endOfWeek(now, { weekStartsOn: 0 });
      break;
    case "lastWeek": {
      const last = subWeeks(now, 1);
      from = startOfWeek(last, { weekStartsOn: 0 });
      to = endOfWeek(last, { weekStartsOn: 0 });
      break;
    }
    case "thisMonth":
      from = startOfMonth(now);
      to = endOfMonth(now);
      break;
    case "lastMonth": {
      const last = subMonths(now, 1);
      from = startOfMonth(last);
      to = endOfMonth(last);
      break;
    }
    case "thisYear":
      from = startOfYear(now);
      to = endOfYear(now);
      break;
    case "lastYear": {
      const last = subYears(now, 1);
      from = startOfYear(last);
      to = endOfYear(last);
      break;
    }
    case "custom":
    default: {
      from = customFrom ? startOfDay(new Date(customFrom)) : startOfMonth(now);
      to = customTo ? endOfDay(new Date(customTo)) : endOfDay(now);
      break;
    }
  }

  return {
    startDate: formatISO(from),
    endDate: formatISO(to),
    from,
    to,
  };
};

export const formatMoney = (value) => {
  const n = Number(value) || 0;
  return n.toLocaleString("ar-EG", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const formatPercent = (value) => {
  const n = Number(value) || 0;
  return `${n.toLocaleString("ar-EG", { maximumFractionDigits: 2 })}%`;
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("ar-EG", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return String(iso);
  }
};
